import Image from '@app/components/image';
import { HomeFeaturedCardContext } from '@app/domains/home/components/HomeFeaturedCard';
import { useContext } from 'react';

export default function CharacterImageLayer() {
    const { characterImageUrl, cardColor } = useContext(HomeFeaturedCardContext);
    return (
        <div className="h-full w-full text-right">
            <div className="relative inline-block h-full">
                <Image className="h-full object-cover" src={characterImageUrl} alt="character-image" />
                <div
                    style={{
                        backgroundImage: `linear-gradient(0deg, ${cardColor}, ${cardColor}00)`,
                    }}
                    className="absolute bottom-0 right-0 h-100 w-full"
                ></div>
            </div>
        </div>
    );
}
